import { Breadcrumbs, Link, styled } from '@mui/material';
import { HelixPalette, HelixStyles } from '../../helix';
/**
 * Styled mui Breadcrumbs, removes the margin for all separators.
 */
export const HelixBreadcrumbs = styled(Breadcrumbs)(() => ({
    '.MuiBreadcrumbs-separator': { margin: 0 },
    'MuiBreadcrumbs-ol': {
        flexWrap: 'nowrap',
    },
    '.MuiBreadcrumbs-li.MuiBreadcrumbs-li': {
        display: 'inline-block',
    },
    'li:first-child': {
        display: 'none',
    },
}));
export const BreadcrumbLink = styled(Link)(() => (Object.assign(Object.assign({}, HelixStyles.style_07), { color: HelixPalette.neutral60, display: 'inline-block', textDecoration: 'none', borderRadius: '0.5rem', padding: '0.175rem', maxWidth: '300px', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', verticalAlign: 'middle', '&:hover': {
        color: HelixPalette.neutral50,
    }, '&:active:focus': {
        color: HelixPalette.neutral80,
    }, ' &:focus-visible': {
        color: HelixPalette.blue70,
        boxShadow: HelixStyles.focusVisible2,
        outline: 'none',
    } })));
